import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=b0ce1c58&scoped=true&"
import script from "./CollectionDetail.vue?vue&type=script&lang=js&"
export * from "./CollectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetail.vue?vue&type=style&index=0&id=b0ce1c58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce1c58",
  null
  
)

export default component.exports